export interface FrameCaptureController {

    stop(): { timestampsMs: number[], elapsedMs: number, frames: number };
}

export function startFrameCapture(videoEl: HTMLVideoElement): FrameCaptureController {
    const timestampsMs: number[] = [];
    let active = true;
    const startTime = performance.now();
    let rafId: number | null = null;
    let rvfcHandle: number | null = null;

    const hasRVFC = typeof (videoEl as any).requestVideoFrameCallback === 'function';
    const hasCancelRVFC = typeof (videoEl as any).cancelVideoFrameCallback === 'function';

    const enqueue = () => {
        if (!active) return;
        if (hasRVFC) {
            rvfcHandle = (videoEl as any).requestVideoFrameCallback((now: number, metadata: any) => {
                if (!active) return;
                const t = (metadata && typeof metadata.mediaTime === 'number')
                    ? metadata.mediaTime * 1000
                    : ((videoEl.currentTime || 0) * 1000);
                timestampsMs.push(t);
                enqueue();
            });
        } else {
            rafId = requestAnimationFrame(() => {
                if (!active) return;
                timestampsMs.push((videoEl.currentTime || 0) * 1000);
                enqueue();
            });
        }
    };

    enqueue();

    return {
        stop(): { timestampsMs: number[]; elapsedMs: number; frames: number } {
            active = false;
            if (rafId !== null) {
                cancelAnimationFrame(rafId);
                rafId = null;
            }
            if (rvfcHandle !== null && hasCancelRVFC) {
                try { (videoEl as any).cancelVideoFrameCallback(rvfcHandle); } catch {}
                rvfcHandle = null;
            }
            const elapsedMs = performance.now() - startTime;
            return { timestampsMs, elapsedMs, frames: timestampsMs.length };
        },
    };
}


